var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"headImg"},[_c('div',{staticClass:"banner"},[_c('img',{attrs:{"src":require("@/assets/leadAroud/dp-ld-sy1.png"),"alt":""}})]),_c('div',{staticClass:"banners"},[_c('img',{attrs:{"src":require("@/assets/leadAroud/dp-ld-sy2.png"),"alt":""}})])])
}]

export { render, staticRenderFns }